import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { LineChart, axisClasses, } from "@mui/x-charts";
import ArticleStore from "./Article-store";
//import { Box, Grid, LinearProgress, Typography, createTheme, useMediaQuery } from "@mui/material";
import { Box, Grid, Typography, createTheme, useMediaQuery } from "@mui/material";


const currentYear = new Date().getFullYear();
const chartSetting = {
  yAxis: [
    {
      label: `No. of Publications from Academic Staff (${
        currentYear - 5
      } - ${currentYear} )`,
      min: 0,
    },
  ],
  width: 900,
  height: 650,
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: "translate(-20px, 0)",
    },
    marginLeft: 0,
  },
};
const color = "#B71704";

export default function BarsDataset() {
  const theme = createTheme(); // You can customize the theme if needed
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [series, setSeries] = React.useState([]);
  const [citations, setCitations] = React.useState([]);

  const blueberryTwilightPaletteLight = ['#02B2AF', '#2E96FF', '#B800D8', '#60009B', '#2731C8', '#03008D'];
  const reversedPalette = blueberryTwilightPaletteLight.reverse();

  
  const dataKeys: string[] = [
    "Total of Last Five Years",
    currentYear.toString(),
    (currentYear - 1).toString(),
    (currentYear - 2).toString(),
    (currentYear - 3).toString(),
    (currentYear - 4).toString(),
    (currentYear - 5).toString(),
  ];

  const dataCitationsKeys: string[] = [
    "Total Citations of Last Five Years",
    currentYear.toString(),
    (currentYear - 1).toString(),
    (currentYear - 2).toString(),
    (currentYear - 3).toString(),
    (currentYear - 4).toString(),
    (currentYear - 5).toString(),
  ];

  async function getSeries() {
    
    let data = await ArticleStore.getSeries();
    setSeries(data);

    let citationsData = await ArticleStore.getCitations();
    setCitations(citationsData);
    }
    

  function getTotalPublications(index: number) {
    let tot = 0;
    series.forEach((s) => {
      tot += s[dataKeys[index]];
    });
    return tot;
  }

  function getTotalCitations(index: number) {
    let tot = 0;
    citations.forEach((s) => {
      tot += s[dataCitationsKeys[index]];
    });
    return tot;
  }
  React.useEffect(() => {
    getSeries();
  });

  if (series.length > 0 && citations.length > 0) {
    return (
      <>
      <Grid container spacing={3} sx={{ marginTop: "10px" }}>
        <Grid container xs={12} md={6.5}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              marginLeft: isMobile? "7%" : "20%",
              fontSize: window.innerWidth > 760 ? 20 : 16,
              textAlign: "center", marginBottom: isMobile? '-10vh' : 0,
            }}
          >
            No. of Publications from Academic Staff ({currentYear - 5} -{" "}
            {currentYear} )
          </Typography>
          <BarChart
            dataset={series}
            xAxis={[
              {
                scaleType: "band",
                dataKey: "memberName",
                tickLabelStyle: {
                  angle: 90,
                  dominantBaseline: "hanging",
                  textAnchor: "start",
                  fontSize: "14px",
                },
                labelStyle: {
                  transform: "translateY(15px)",
                },
              },
            ]}
            series={[
              {
                data: series.map((s) => s[dataKeys[6]]),
                stack: "A",
                label: dataKeys[6],
              },
              {
                data: series.map((s) => s[dataKeys[5]]),
                stack: "A",
                label: dataKeys[5],
              },
              {
                data: series.map((s) => s[dataKeys[4]]),
                stack: "A",
                label: dataKeys[4],
              },
              {
                data: series.map((s) => s[dataKeys[3]]),
                stack: "A",
                label: dataKeys[3],
              },
              {
                data: series.map((s) => s[dataKeys[2]]),
                stack: "A",
                label: dataKeys[2],
              },
              {
                data: series.map((s) => s[dataKeys[1]]),
                stack: "A",
                label: dataKeys[1],
              },
            ]}
            margin={{ bottom: window.innerWidth > 700 ? 200 : 0, left: 100 }}
            colors={reversedPalette}
            {...chartSetting}
          />
        </Grid>
        
        <Grid container xs={12} md={5}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              marginLeft: isMobile? "7%" : "15%",
              fontSize: window.innerWidth > 760 ? 20 : 16,
              textAlign: "center",
            }}
          >
           Total Publications of Academic Staff against Year (
            {currentYear - 5} - {currentYear} )
          </Typography>
          <LineChart
            xAxis={[
              {
                scaleType: "point",
                data: dataCitationsKeys.filter((key) => key !== dataCitationsKeys[0]).reverse(),
              },
            ]}
            series={[
              {
                data: [
                  getTotalPublications(6),
                  getTotalPublications(5),
                  getTotalPublications(4),
                  getTotalPublications(3),
                  getTotalPublications(2),
                  getTotalPublications(1),
                ],
                color: color,
              },
            ]}
            margin={{ bottom: 145, left: 100 }}
            {...chartSetting}
            width={600}
            height={550}
          />
        </Grid>
      </Grid>
       <Grid container spacing={3} sx={{ marginTop: "10px" }}>
        <Grid container xs={12} md={6.5}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              marginLeft: isMobile? "7%" : "20%",
              fontSize: window.innerWidth > 760 ? 20 : 16,
              textAlign: "center", marginBottom: isMobile? '-10vh' : 0,
            }}
          >
            Citations Count of  Academic Staff ({currentYear - 5} -{" "}
            {currentYear} )
          </Typography>
          <BarChart
            dataset={series}
            xAxis={[
              {
                scaleType: "band",
                dataKey: "memberName",
                tickLabelStyle: {
                  angle: 90,
                  dominantBaseline: "hanging",
                  textAnchor: "start",
                  fontSize: "14px",
                },
                labelStyle: {
                  transform: "translateY(15px)",
                },
              },
            ]}
            series={[
              {
                data: citations.map((s) => s[dataCitationsKeys[6]]),
                stack: "A",
                label: dataCitationsKeys[6],
              },
              {
                data: citations.map((s) => s[dataCitationsKeys[5]]),
                stack: "A",
                label: dataCitationsKeys[5],
              },
              {
                data: citations.map((s) => s[dataCitationsKeys[4]]),
                stack: "A",
                label: dataCitationsKeys[4],
              },
              {
                data: citations.map((s) => s[dataCitationsKeys[3]]),
                stack: "A",
                label: dataCitationsKeys[3],
              },
              {
                data: citations.map((s) => s[dataCitationsKeys[2]]),
                stack: "A",
                label: dataCitationsKeys[2],
              },
              {
                data: citations.map((s) => s[dataCitationsKeys[1]]),
                stack: "A",
                label: dataCitationsKeys[1],
              },
            ]}
            margin={{ bottom: window.innerWidth > 700 ? 200 : 0, left: 100 }}
            colors={reversedPalette}
            {...chartSetting}
          />
        </Grid>
        
        <Grid container xs={12} md={5}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              marginLeft: isMobile? "7%" : "15%",
              fontSize: window.innerWidth > 760 ? 20 : 16,
              textAlign: "center",
            }}
          >
           Total  Ciations Count of Academic Staff against Year (
            {currentYear - 5} - {currentYear} )
          </Typography>
          <LineChart
            xAxis={[
              {
                scaleType: "point",
                data: dataCitationsKeys.filter((key) => key !== dataCitationsKeys[0]).reverse(),
              },
            ]}
            series={[
              {
                data: [
                  getTotalCitations(6),
                  getTotalCitations(5),
                  getTotalCitations(4),
                  getTotalCitations(3),
                  getTotalCitations(2),
                  getTotalCitations(1),
                ],
                color: color,
              },
            ]}
            margin={{ bottom: 145, left: 100 }}
            {...chartSetting}
            width={600}
            height={550}
          />
        </Grid>
      </Grid>
      </>
      
    );
  } else {
    return (
      <Box
        style={{
          width: "100%",
          height: "80vh",
        }}
      >
        {/* <LinearProgress color="secondary" /> */}
      </Box>
    );
  }
}
